import React, { forwardRef } from "react";
import "../ui/rc-ui.scss";
import "./PageLayout.scss";

/**
 * The page shell — `.rc-page`. Every route renders exactly one, wrapping its
 * `<PageHeader>` and all of its content:
 *
 *   <PageLayout className="my-page">
 *     <PageHeader … />
 *     … page content …
 *   </PageLayout>
 *
 * It is the only element allowed to declare the horizontal page gutter. Sections
 * inside it run at 100% of that content box and add nothing horizontal of their
 * own; a section that paints a full-width band breaks out and re-pads (see
 * `.claude/features/page-chrome.md`).
 *
 * There is no variant prop. A `flush` one existed to drop the gutter for pages
 * that supplied their own shell — there are none left, and the whole point of
 * having one shell is that a page cannot opt out of it.
 */
const PageLayout = forwardRef(function PageLayout(
  { children, className = "", ...rest },
  ref
) {
  return (
    <div ref={ref} className={["ft-page", "rc-page", className].filter(Boolean).join(" ")} {...rest}>
      {children}
    </div>
  );
});

export default PageLayout;
